import { createSearchApi } from './searchApi';
import { toProjectsApiParams } from './projectsApiParams';
import { routes } from './routes';

// Module scope, not per createProjectsApi() call: ProjectMap remounts on the
// list <-> map view switch and hovering the same marker twice must not
// refetch. The promise is cached rather than the payload so concurrent hovers
// dedupe; a failure is evicted so the next hover retries.
const detailRequests = new Map();

// Suggest is shared with the listing search: /web-api/suggest already returns
// projects and places, exactly what the projects page needs.
export const createProjectsApi = () => {
  const { suggest } = createSearchApi();

  return {
    suggest,

    search: async (criteria, page = 1, bbox = null) => {
      const response = await fetch(
        `${routes.projectsSearchApi}?${toProjectsApiParams(criteria, page, bbox)}`,
        { headers: { Accept: 'application/json' } }
      );
      if (!response.ok) throw new Error(`Search request failed (${response.status})`);
      return response.json();
    },

    detail: (id) => {
      const url = `${routes.projectsDetailApi}/${id}`;
      const cached = detailRequests.get(url);
      if (cached) return cached;

      const request = fetch(url, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error(`Detail request failed (${response.status})`);
          return response.json();
        })
        .catch((error) => {
          detailRequests.delete(url);
          throw error;
        });
      detailRequests.set(url, request);

      return request;
    }
  };
};
